import { AddButtonIcon } from '@/assets/static/icons/add-button-icon';
import { themeVar } from '@/styles/theme';
import styled from 'styled-components';
import Button from '../../basicComponents/button';

interface SectionZeroStateProps {
  text?: string;
  button: {
    name: string;
    icon?: React.ReactNode;
    onClick: () => void;
  };
}

const SectionZeroState = ({ text, button }: SectionZeroStateProps) => {
  return (
    <SectionZeroStateWrapper>
      <SectionZeroStateText>{text || 'No information has been added yet.'}</SectionZeroStateText>
      <Button
        onClick={button.onClick}
        styleType="outline"
        icon={button?.icon || <AddButtonIcon fill={themeVar('font.action')} />}
        size="md"
        width="max-content"
      >
        {button.name}
      </Button>
    </SectionZeroStateWrapper>
  );
};

export default SectionZeroState;

const SectionZeroStateWrapper = styled.div`
  display: flex;
  gap: 10px;
  flex-direction: column;
`;

const SectionZeroStateText = styled.div`
  padding: 10px 0;
  font-size: 19px;
  font-weight: 400;
  line-height: 26.6px;
  color: ${themeVar('font.weak')};
`;
